<template>
  <div>
    <UtteranceControl
      :content="content"
      :isLoading="isLoading"
      :disabled-enter="portalDisabled"
      v-on="$listeners"
      @disabledEnter="handleMessage"
    ></UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';
import { Context } from 'vm';
import { Sequence } from '@forchange/storytime';

@Component({
  components: {
    UtteranceControl
  }
})
export default class PortalControl extends Vue {
  @Prop({type: Object}) content: Context & {
    portalSequence: Sequence;
    mustRead: string
  }
  @Prop({ type: Boolean }) isLoading!: boolean;

  get portalDisabled() {
    return !this.content.portalSequence && ['是', true].includes(this.content.mustRead)
  }

  handleMessage() {
    this.$store.commit('common/setPortalMessage', {
      animation: true
    })
    this.$Message.info({
      time: 1500,
      content: '请点击卡片进行学习哦'
    })
  }
}
</script>
